"use client"

import { useRef } from "react"

const AudioUploader = ({ name, audioFile, setAudioFile, disabled }) => {
  const fileInputRef = useRef(null)

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type.startsWith("audio/")) {
      setAudioFile(file)
    } else {
      alert("Please select an audio file (MP3, WAV, etc.)")
      // Clear the input value to allow re-selection
      if (fileInputRef.current) {
        fileInputRef.current.value = ""
      }
    }
  }

  const handleClick = () => {
    // Clear the input value before opening file dialog
    // This ensures onChange fires even for the same file
    if (fileInputRef.current) {
      fileInputRef.current.value = ""
    }
  }

  return (
    <div className="audio-uploader-container">
      <label className={`upload-button ${disabled ? "disabled" : ""}`}>
        {audioFile ? audioFile.name : name}
        <input
          ref={fileInputRef}
          type="file"
          accept="audio/*"
          onChange={handleFileChange}
          onClick={handleClick}
          disabled={disabled}
          style={{ display: "none" }}
        />
      </label>

      {audioFile && (
        <div className="file-info">
          <span>Selected: {audioFile.name}</span>
          <span>Size: {(audioFile.size / (1024 * 1024)).toFixed(2)} MB</span>
        </div>
      )}
    </div>
  )
}

export default AudioUploader
